<template>
  <collapsible-section
    class="collapse-item"
    :id="`objectModelLinkedSubmissionsCollapse-${dropdownControlId}`"
    control-name="objectModelLinkedSubmissionsCollapse"
    :is-open="false"
  >
    <template #section-header>
      Linked Submissions
    </template>

    <template #section-contents>
      <section-fields
        :q="q"
        icon-glyph="form"
        :handler="handler"
        :section="linkedFormsSection"
        :select-additional-parameters="selectionArguments"
        @select="select"
      ></section-fields>
    </template>
  </collapsible-section>
</template>

<script lang="ts">
  import Vue from 'vue';
  import handlerComponentsMixin from '~/components/dynamicFieldsTrees/mixins/handlerComponentsMixin';
  import handlerTreeContextMixin from '~/components/dynamicFieldsTrees/mixins/handlerTreeContextMixin';
  import SectionFields from '~/components/dynamicFieldsTrees/handlerComponents/common/section-fields.vue';
  import ProcessFlowObjectModelDynamicFieldsHandler
    from '~/models/dynamicFields/handlers/processFlows/processFlowObjectModelDynamicFieldsHandler';
  import ObjectModel from '~/models/objectModel';
  import { ReferencePathNode } from '~/models/referencePaths/referencePathNode';
  import { IObjectModelLinkedFormsSection } from '~/interfaces/dynamicFieldsInterfaces';

  export default Vue.extend({
    mixins: [
      handlerComponentsMixin,
      handlerTreeContextMixin,
    ],
    components: {
      SectionFields,
    },
    props: {
      handler: {
        type: Object as () => ProcessFlowObjectModelDynamicFieldsHandler,
        required: true,
      },
      objectModel: {
        type: Object as () => ObjectModel,
        required: true,
      },
      path: {
        type: Array as () => ReferencePathNode[],
        required: false,
      },
    },
    computed: {
      linkedFormsSection(): IObjectModelLinkedFormsSection {
        return this.handler.linkedFormsSection(this.lowerQ, this.objectModel);
      },
      selectionArguments(): Array<any> {
        return [this.objectModel, this.path];
      },
    },
  })
  ;
</script>